import styled from 'styled-components'

import { Drawer } from '@acorns/web-components'
import { CarrotArrowIcon, CircleCheckIcon, EarnRewardIcon, CircleXIcon } from '@acorns/grove/icons'

import { Button, FlatButton, TextInput, theme } from '@acorns/grove'

export const PromoCodesContainer = styled.div`
  font-size: ${theme.fontSize._14};
  font-weight: ${theme.fontWeight.demiBold};
  line-height: ${theme.lineHeight._22};
  text-align: center;

  @media screen and (max-width: ${theme.dimensions.breakpointsSmall}px) {
    order: 2;
  }
`

export const StyledDrawer = styled(Drawer)`
  width: 420px;

  > div {
    width: 100%;
  }

  @media screen and (max-width: ${theme.dimensions.breakpointsSmall}px) {
    width: 100%;
  }
`

export const PromoCodesDrawerInputForm = styled.form`
  position: relative;
  margin-bottom: 56px;
  margin-top: 10px;
  width: 100%;

  @media screen and (max-width: ${theme.dimensions.breakpointsSmall}px) {
    margin-bottom: 66px;
  }
`

export const StyledDrawerBanner = styled.div`
  @media screen and (max-width: ${theme.dimensions.breakpointsSmall}px) {
    height: 160px;
  }
  @media screen and (width: 430px), screen and (width: 540px) {
    height: initial;
  }
  @media screen and (width: 414px), screen and (width: 390px), screen and (width: 412px) {
    margin-bottom: 20px;
  }
`

export const DrawerBannerTitle = styled.span`
  font-size: ${theme.fontSize._16};
  font-weight: ${theme.fontWeight.demiBold};
  line-height: ${theme.lineHeight._24};
  margin: 0;
  padding: 0;
`

export const DrawerBannerDescription = styled.p`
  font-size: ${theme.fontSize._14};
  font-weight: ${theme.fontWeight.regular};
  line-height: ${theme.lineHeight._22};
  margin: 10px 0 0;
  padding: 0;
`

export const StyledEarnRewardIcon = styled(EarnRewardIcon)`
  position: relative;
  margin-right: 10px;
  top: 6px;

  > path {
    fill: ${theme.colors.primaryWhite};
  }
`

export const ContextualDetailsContainer = styled.div<{ isCtaEnabled?: boolean }>`
  border-radius: 10px;
  border: 2px solid ${theme.colors.primaryGreen};
  color: ${theme.colors.primaryForest};
  cursor: ${(props) => (props.isCtaEnabled ? 'pointer' : 'inherit')};
  font-size: ${theme.fontSize._14};
  line-height: ${theme.lineHeight._22};
  overflow: hidden;
  padding: 20px 16px 20px 38px;
  position: relative;
  max-width: 340px;
  margin: 0 auto;
  width: 100%;

  @media (min-width: ${theme.dimensions.breakpointsSmall}px) {
    max-width: 100%;
    position: relative;
    top: 55px;
  }

  @media (max-width: ${theme.dimensions.breakpointsSmall}px) {
    bottom: 125px;
    left: 0;
    position: relative;
    right: 0;
  }

  @media (max-width: 400px) {
    margin: 0;
    min-width: 220px;
  }

  @media screen and (min-height: 650px) and (max-width: ${theme.dimensions.breakpointsSmall}px) {
    bottom: 85px;
    position: absolute;
    width: calc(100% - 60px);
  }

  @media screen and (min-height: 650px) and (max-width: 400px) {
    left: 30px;
  }
`

export const ContextualDetailsContainerBackground = styled.div`
  background-color: ${theme.colors.primaryGreen};
  height: 100%;
  left: 0;
  opacity: 0.1;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
`

export const ContextualDetailsTitle = styled.h3`
  font-weight: ${theme.fontWeight.demiBold};
  margin: 0;
  padding: 0;
  position: relative;
  font-size: ${theme.fontSize._14};
`

export const ContextualDetailsCondensedTitle = styled.p`
  padding: 0;
  margin: 0;
  font-weight: ${theme.fontWeight.regular};
`

export const AppliedCodeCta = styled(FlatButton)`
  color: ${theme.colors.primaryForest};
  font-size: ${theme.fontSize._12};
  font-weight: ${theme.fontWeight.demiBold};
  line-height: ${theme.lineHeight._16};
  margin-top: 10px;
  padding: 0;
`

export const LoaderContainer = styled.div`
  top: 50px;
  position: relative;
  display: flex;
  align-items: center;
  margin: auto;

  @media (max-width: ${theme.dimensions.breakpointsSmall}px) {
    position: fixed;
    left: 50%;
    top: 80%;
    transform: translateX(-50%);
  }
`

export const StyledCircleCheckIcon = styled(CircleCheckIcon)`
  left: -19px;
  position: absolute;
  top: 5px;
  > path {
    fill: ${theme.colors.primaryForest};
  }
`

export const StyledCarrotArrowIcon = styled(CarrotArrowIcon)`
  position: relative;
  margin-left: 2px;
  top: 2px;
  > rect {
    fill: transparent;
  }
  > path {
    fill: ${theme.colors.primaryForest};
  }
`
export const StyledTextInput = styled(TextInput)<{ error: boolean }>`
  & > div {
    border: ${({ error }) =>
      error ? `2px solid ${theme.colors.adaDarkRed}` : `2px solid transparent`};
  }
`
export const PromoCodeSubTextContainer = styled.div<{ isValidSubTextShown: boolean }>`
  position: absolute;
  top: 66px;
  display: flex;
  gap: 10px;
  color: ${(props) =>
    props.isValidSubTextShown ? theme.colors.primaryGreen : theme.colors.adaDarkRed};
  font-size: ${theme.fontSize._12};
  align-items: center;
`

export const StyledCircleXIcon = styled(CircleXIcon)`
  width: 12px;
  height: 12px;
  align-self: center;

  > path {
    fill: ${theme.colors.adaDarkRed};
  }
`
export const StyledCircleCheckIconSubText = styled(CircleCheckIcon)`
  width: 12px;
  height: 12px;
  align-self: center;

  > path {
    fill: ${theme.colors.primaryGreen};
  }
`
export const ValidationSubText = styled.span`
  position: relative;
  top: 1px;
`

export const TermsAndConditions = styled.a`
  display: flex;
  color: ${theme.colors.primaryStoneLight};
  font-size: ${theme.fontSize._12};
  text-decoration: none;
  font-weight: ${theme.fontWeight.demiBold};
  line-height: ${theme.lineHeight._16};
  margin-top: 10px;
`

export const StyledButton = styled(Button)`
  background-color: ${theme.colors.primaryIvory};
  max-width: 175px;
  color: ${theme.colors.naturalMushroom};
  font-size: ${theme.fontSize._14};
  line-height: ${theme.lineHeight._22};
  &:hover {
    background-color: ${theme.colors.primaryIvory};
  }
`
